import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, imgUrl } from "@/lib/api";
import { Flame, TrendingUp } from "lucide-react";

const medalColor = (i) => (i === 0 ? "#D4AF37" : i === 1 ? "#C0C0C0" : "#CD7F32");

export const TopSelling = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products/top-selling", { params: { limit: 3 } })
      .then(({ data }) => setItems(data))
      .finally(() => setLoading(false));
  }, []);

  if (loading || items.length === 0) return null;

  return (
    <section className="bg-[#0A0A0A] py-20 border-t border-white/5" data-testid="top-selling-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-end justify-between mb-12 flex-wrap gap-3">
          <div>
            <div className="font-overline text-xs text-[#D4AF37] mb-3 flex items-center gap-2">
              <Flame className="w-4 h-4" /> — SCELTI DAI NOSTRI CLIENTI
            </div>
            <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-none">
              I PRODOTTI<br />PIÙ <span className="text-[#D4AF37]">SCELTI</span>
            </h2>
          </div>
          <Link to="/catalog" className="font-overline text-[10px] text-neutral-400 hover:text-[#D4AF37] transition-colors flex items-center gap-1" data-testid="view-all-link">
            SCOPRI → <TrendingUp className="w-3 h-3" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((p, i) => (
            <Link
              key={p.product_id}
              to={`/product/${p.product_id}`}
              className="group relative border border-white/10 bg-[#141414] hover:border-[#D4AF37]/60 transition-colors overflow-hidden"
              data-testid={`top-selling-${i + 1}`}
            >
              {/* Medal */}
              <div className="absolute top-3 left-3 z-10 w-14 h-14 flex items-center justify-center bg-black/60 backdrop-blur border" style={{ borderColor: medalColor(i) }}>
                <span className="font-display font-black text-2xl" style={{ color: medalColor(i) }}>#{i + 1}</span>
              </div>
              {/* Qty badge */}
              <div className="absolute top-3 right-3 z-10 px-2 py-1 bg-black/60 backdrop-blur border border-[#D4AF37]/40">
                <span className="font-overline text-[9px] text-[#D4AF37]">{p.sold_qty} VENDUTI</span>
              </div>

              <div className="aspect-square bg-black overflow-hidden">
                <img
                  src={imgUrl(p.image_url, 600)} decoding="async"
                  alt={p.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="font-overline text-[9px] text-neutral-500 mb-1">{p.brand}</div>
                <div className="font-display font-black text-lg leading-tight mb-2 group-hover:text-[#D4AF37] transition-colors">{p.name}</div>
                <div className="flex items-end justify-between">
                  <div className="font-display font-black text-2xl text-white">€{Number(p.price).toFixed(2)}</div>
                  <div className="font-overline text-[9px] text-[#D4AF37]">SCOPRI →</div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
